// extracted by mini-css-extract-plugin
module.exports = {"app":"bk_c1","appTitle":"bk_c2","bigCard":"bk_f3","appSubtitle":"bk_f4","appSubtitle_dark":"bk_f5","iconContent":"bk_f6","bigIcon":"bk_f7"};